import React, { useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/organizationFileAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import {
  Card,
  CardFooter,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import OrganizationDetailForm from "./OrganizationDetailForm";
import { Formik } from "formik";

export const OrganizationDetailCard = ({ history }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.fetchOrganization());
  }, [dispatch]);

  const { actionsLoading, organizationForEdit = {} } = useSelector(
    state => state.organizationFiles,
    shallowEqual
  );

  const updateOrgOwnerUser = values => {
    console.log(`values`, values);
    const data = {
      name: values.name,
      call_center: values.call_center,
      user: { name: values.user.name, uuid: values.user.uuid }
    };
    console.log(`data`, data);
    dispatch(actions.updateOrgOwnerUser(values))
      .then(res => {
        toast.success(res.message, toastOption);
        dispatch(actions.fetchOrganization());
      })
      .catch(err => {
        toast.error("Failed update data", toastOption);
        dispatch(actions.fetchOrganization());
      });
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={organizationForEdit}
        onSubmit={values => updateOrgOwnerUser(values)}
      >
        {({ setFieldValue, values, handleSubmit }) => (
          <Card>
            <CardHeader title={`Lembaga ${organizationForEdit.name}`} />
            <OrganizationDetailForm
              data={organizationForEdit}
              setFieldValue={setFieldValue}
              values={values}
            />
            <CardFooter>
              <button
                className="btn btn-primary float-right"
                onClick={handleSubmit}
              >
                Update
              </button>
            </CardFooter>
          </Card>
        )}
      </Formik>
    </>
  );
};
